import { I18n } from '../../ol-pdf-printer';

export const es: I18n = {
    printPdf: 'Exportar PDF',
    pleaseWait: 'Por favor espere...',
    downloadFinished: 'Descarga completada, procesando...',
    downloadingImages: 'Descargando imágenes',
    error: 'Error al generar pdf',
    errorImage: 'Ocurrió un error al tratar de cargar una imagen',
    printing: 'Exportando',
    cancel: 'Cancelar',
    close: 'Cerrar',
    print: 'Exportar',
    mapElements: 'Elementos en el mapa',
    extraInfo: 'Información adicional',
    url: 'URL',
    date: 'Fecha',
    specs: 'Especificaciones',
    compass: 'Brújula',
    scale: 'Escala',
    legends: 'Leyendas',
    layersAttributions: 'Atribuciones de capas',
    addNote: 'Agregar nota (opcional)',
    resolution: 'Resolución',
    orientation: 'Orientación',
    paperSize: 'Tamaño de página',
    landscape: 'Paisaje',
    portrait: 'Retrato',
    current: 'Actual',
    paper: 'Hoja',
    printerMargins: 'Añadir márgenes de impresión',
    escapeHint: 'Presioná aquí o Escape para cancelar',
    reframeHint: 'Ajustá la región de interés paneando y zoomeando',
    process: 'Procesar'
};
